import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { User } from '../../models/user';
import { ErrorService } from '../../services/error.service';
import { OrderService } from '../../services/order.service';
import { SpinnerService } from '../../services/spinner.service';
import { UserService } from '../../services/user.service';
import { CustomerService } from '../../services/customer.service';

@Component({
	selector: 'app-recent-orders-modal',
	templateUrl: './recent-orders-modal.html'
})

export class RecentOrdersModalComponent implements OnInit, OnDestroy {
	public dataSource = new MatTableDataSource<any>();
	public displayedColumns: string[] = ['origin', 'destination', 'orderType', 'action'];
	public numberOfOrdersToGet = 10;
	public user: User;
	public selectedCustomer: any;
	private userSubscription: any;

	constructor(private _errorService: ErrorService,
				private _orderService: OrderService,
				private _userService: UserService,
				private _customerService: CustomerService,
				public dialogRef: MatDialogRef<RecentOrdersModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any,
				private _spinnerService: SpinnerService) {

	}

	cancelOrder(order) {
		this._orderService.handleCancelOrder(order);
	}

	closeModal() {
		this.dialogRef.close();
	}

	getSelectedCustomer(): void {
		if (this.user && this.user.token && this.user.type === 'inet') {
			this.selectedCustomer = this._customerService.getSelectedCustomer();
		}
	}

	getRecentOrders(searchCriteria?) {
		this._spinnerService.startSpinner();
		this._orderService.getRecentOrders(searchCriteria, this.numberOfOrdersToGet, this.selectedCustomer?.id).subscribe(response => {
            this.dataSource.data = response;
            this.dataSource.data.forEach((order) => {
                order.validOrder = this.isValidOrder(order);
            });
			this._spinnerService.stopSpinner();
		}, error => {
			this._errorService.error(error, 'getRecentOrders Failed');
			this._spinnerService.stopSpinner();
		});
	}

	ngOnInit() {
		this.userSubscription = this._userService.user$.subscribe((user) => {
			this.user = user;
			this.getSelectedCustomer();
		  this.getRecentOrders();
		});
	}

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

	selectOrderAction(action, orderId) {
		if (action !== 'addToCart') {
			this.dialogRef.close({action, orderId});
		} else if (this.data.hasOwnProperty('addToCart')) {
			this.data.addToCart({action, orderId});
		}
	}

	setNumberOfOrdersToGet(num) {
		this.numberOfOrdersToGet = num;
		this.getRecentOrders();
    }

    isValidOrder(order) {
        if ((order.destination.id && !order.destIdIsValid) || (order.origin.id && !order.originIdIsValid)) {
            return false;
        } else {
            return true;
        }
    }
}
